import axios from '../erp/configAxios'

export const confirmClientApi = async (user_id, requestData) => {
    return await axios.post(`/${user_id}/confirm/`, requestData);
  };